<div class="container-carregando">
  <p-progressSpinner
    [style]="{width: '20px', height: '20px'}"
    strokeWidth="2"
    fill="#FFF"
    animationDuration="2s">
  </p-progressSpinner>
  <label class="texto-cinza label-carregando">Carregando...</label>
</div>
